<script>

import { Overlay } from '../../'

export default {
    name: 'NVI',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Negative Volume Index - Tracks price movement on low volume days',
                preset: {
                    name: 'NVI $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#3f51b5'
                    }
                }
            }
        },
        use_for() { return ['NVI'] },
        calc() {
            return {
                props: {
                    length: { def: 255, text: 'Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let index = ts(1000)
                    let previous = Number.isFinite(index[1]) ? index[1] : 1000
                    index[0] = vol[0] < vol[1] && close[1] ? previous * close[0] / close[1] : previous
                    return ema(index, length)[0]
                `
            }
        }
    }
}
</script>
